import React, { useState, useEffect, useContext } from "react";
import { useParams } from "react-router-dom";
import { useLazyQuery, useQuery, useMutation } from "@apollo/client";
import { useStorage } from "../../hook/useStorage";

import {

  ReplyModal,
  ReviewsSection,
  BoardSection,
} from "../components";
import WriteReviewModal from "../../genericComponents/WriteReviewModal"

// import { Footer, LoaderModal } from "../../genericComponents";
import { img_board } from "../../../assets/images";
import { GApageView } from "../../../app";
import { Context } from "../../../context/globalContext";
import LoaderBals from "../../genericComponents/LoaderBals";
import { RESOURCE_DETAIL, GET_LOCKER, GET_RESOURCE_COMMENTS, GET_RESOURCE_PERCENTAGE, GET_HELPFUL_REVIEWS } from "../../../helpers/graphqlQueries";
import { ADD_HELPFUL_REVIEW, ADD_RESOURCE_TO_LOCKER, DELETE_FROM_LOCKER, DELETE_HELPFUL_REVIEW } from "../../../helpers/graphqlMutations";

const Product = () => {
  let { id } = useParams();
  GApageView(`Product ${id}`);

  const {
    state: { user },
  } = useContext(Context);
  const email = user.email;
  const [onLocker, setOnLocker] = useState(false);
  const [comments, setComments] = useState([]);
  const [offset, setOffset] = useState(0);
  const [modalVisibility, setModalVisibility] = useState(false);
  const [writeReviewId, setwriteReviewId] = useState("");
  const [writeReviewName, setwriteReviewName] = useState("");

  const [replyModal, setReplyModal] = useState({
    commentId: "",
    visibility: false,
  });
  const [resourceDetail, setResourceDetail] = useState({
    name: "",
    description: "",
    rating: 0,
    reviewsCount: 1,
    picture_name: "",
    link: "",
    stars_1: 0,
    stars_2: 0,
    stars_3: 0,
    stars_4: 0,
    stars_5: 0,
  });
  const [helpfulReviews, setHelpfulReviews] = useState([]);
  const [imageUrl, setImageUrl] = useState(img_board);

  //gql
  const {
    loading: loadingLocker,
    data: lockerResponse,
    refetch: fetchLocker,
  } = useQuery(GET_LOCKER, { variables: { email } });

  const { refetch: fetchHelpfulReviews } = useQuery(GET_HELPFUL_REVIEWS, {
    onCompleted: (data) => {
      setHelpfulReviews(data.helpful_review);
    },
    variables: {
      resourceId: id,
      userId: email,
    },
    notifyOnNetworkStatusChange: true,
  });

  const [fetchComments, { loading: loadingComments }] = useLazyQuery(
    GET_RESOURCE_COMMENTS,
    {
      onCompleted: (data) => {
        setComments((prevComments) => [
          ...prevComments,
          ...data.resourceComments,
        ]);
      },
    }
  );

  const [refetchCurrentComments] = useLazyQuery(GET_RESOURCE_COMMENTS, {
    onCompleted: (data) => setComments((prevComments) => data.resourceComments),
  });

  const [removeFromLocker] = useMutation(DELETE_FROM_LOCKER);
  const [addToLocker] = useMutation(ADD_RESOURCE_TO_LOCKER);
  const [addHelpfulReview] = useMutation(ADD_HELPFUL_REVIEW, {
    onCompleted: () => {
      fetchHelpfulReviews();
    },
  });
  const [removeHelpfulReview] = useMutation(DELETE_HELPFUL_REVIEW, {
    onCompleted: () => {
      fetchHelpfulReviews();
    },
  });

  const { loading: loadingResource } = useQuery(RESOURCE_DETAIL, {
    variables: { id },
    onCompleted: (data) => {
      setResourceDetail(data.resource);
    },
    onError: (err) => console.log(err),
  });
  const [fetchResource] = useLazyQuery(RESOURCE_DETAIL, {
    onCompleted: (data) => setResourceDetail((prev) => data.resource),
  });

  const { data, loading: loadingPercentage } = useQuery(
    GET_RESOURCE_PERCENTAGE,
    { variables: { resourceId: id } }
  );

  const handleLockerButtonPress = async (isOnLocker) => {
    try {
      if (isOnLocker) {
        await removeFromLocker({
          variables: {
            user_id: email,
            resource_id: id,
          },
        });
      } else {
        await addToLocker({
          variables: {
            user_id: email,
            resource_id: id,
          },
        });
      }
      fetchLocker();
    } catch (err) {
      console.log("Error: ", err);
    }
  };

  useEffect(() => {
    if (lockerResponse) {
      const index = lockerResponse.resources_locker.findIndex(
        (lockerResource) => lockerResource.resource_id === id
      );
      setOnLocker(index > -1);
    }
  }, [lockerResponse, resourceDetail.picture_name]);

  const url = useStorage(`resources/${resourceDetail.picture_name}`);
  useEffect(() => {
    setImageUrl(url);
  }, [url]);

  useEffect(() => {
    fetchComments({ variables: { id, limit: 10, offset: 0 } });
  }, []);

  const handleLoadMore = () => {
    setOffset((prevOffset) => {
      const newOffset = prevOffset + 10;
      fetchComments({ variables: { id, limit: 10, offset: newOffset } });

      return newOffset;
    });
  };

  const reloadCurrentComments = () => {
    refetchCurrentComments({ variables: { id, limit: offset, offset: 0 } });
    fetchResource();
  };

  const markReviewAsHelpful = (commentId, isHelpful) => {
    if (!isHelpful)
      addHelpfulReview({
        variables: {
          commentId,
          userId: email,
          resourceId: id,
        },
      });
    else {
      removeHelpfulReview({
        variables: {
          commentId,
          userId: email,
        },
      });
    }
  };

  // storageFB
  //   .ref('resources/')
  //   .child(`${resourceDetail.picture_name}`)
  //   .getDownloadURL()
  //   .then(url => {
  //     setImageUrl(url);
  //   })
  //   .catch(err => {
  //     console.log({
  //       err,
  //     });
  //   });

  const handleWriteReview = (idResource, resourceName) => {
    setwriteReviewId(idResource);
    setwriteReviewName(resourceName);
    setModalVisibility(true);
  }

  const handleOnClose = () => {
    reloadCurrentComments();
    setModalVisibility(false);

  };

  // const stars = {
  //   stars_1: resourceDetail.stars_1,
  //   stars_2: resourceDetail.stars_2,
  //   stars_3: resourceDetail.stars_3,
  //   stars_4: resourceDetail.stars_4,
  //   stars_5: resourceDetail.stars_5,
  // };

  return loadingResource ||
    loadingLocker ||
    loadingPercentage ||
    loadingComments ? (

      <LoaderBals />
    ) : (
      <section id='page_content'>
        <BoardSection
          id={id}
          title={resourceDetail.name}
          description={resourceDetail.description}
          rating={resourceDetail.rating}
          reviewsCount={resourceDetail.reviewsCount}
          onLocker={onLocker}
          onLockerButtonPress={handleLockerButtonPress}
          handleCreateReview={handleWriteReview}
          imageUrl={imageUrl}
          link={resourceDetail.link}
        />
        <ReviewsSection
          id={id}
          title={resourceDetail.name}
          loadMore={handleLoadMore}
          comments={comments.map((comment) => {
            const isHelpful = !!helpfulReviews.filter(
              (review) => review.resource_review_id === comment.id
            ).length;
            return isHelpful ? { ...comment, isHelpful: true } : comment;
          })}
          handleReply={setReplyModal}
          markReviewAsHelpful={markReviewAsHelpful}
          stars={resourceDetail}
          reviewsCount={resourceDetail.reviewsCount}
          rating={resourceDetail.rating}
          handleCreateReview={handleWriteReview}
        />
        {/* <ResourcesSection /> */}
        {modalVisibility && (
          <WriteReviewModal isShow={modalVisibility} onClose={handleOnClose} idResource={writeReviewId} resourceName={writeReviewName} />
        )}
        {replyModal.visibility && (
          <ReplyModal
            onClose={() => setReplyModal({ visibility: false, commentId: "" })}
            commentId={replyModal.commentId}
            handleReload={reloadCurrentComments}

          />
        )}

      </section>
    );
};

export default Product;
